/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useRef } from "react";
import Slider from "react-slick";
import Media from "@qlik/qlik/src/components/Media";
import RichText from "@qlik/qlik/src/components/RichText";
import { getCardMedia } from "@qlik/qlik/src/lib/util/helpers";
import Cta from "@qlik/qlik/src/components/Cta";
import { debounce } from "@qlik/qlik/src/lib/utils";
import * as styles from "./styles.module.css";

const MobileTabsScrollingSection = ({ data }) => {
    const settings = {
        dots: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
    };
    const sectionRef = useRef(null);
    useEffect(() => {
        const cardTitles = sectionRef.current.querySelectorAll(`.card-title`);
        let maxTitleHeight = 0;

        cardTitles.forEach((title) => {
            const titleHeight = title.offsetHeight;
            maxTitleHeight = Math.max(maxTitleHeight, titleHeight);
        });

        cardTitles.forEach((title) => {
            title.style.height = `${maxTitleHeight}px`;
        });
        const handleResize = () => {
            cardTitles.forEach((title) => {
                title.style.height = "auto";
            });
            maxTitleHeight = 0;
            cardTitles.forEach((title) => {
                const titleHeight = title.offsetHeight;
                maxTitleHeight = Math.max(maxTitleHeight, titleHeight);
            });

            cardTitles.forEach((title) => {
                title.style.height = `${maxTitleHeight}px`;
            });
        };

        const DEBOUNCE_THRESHOLD = 250;
        const debouncedResizeHandler = debounce(handleResize, DEBOUNCE_THRESHOLD);
        // Set up event listener for window resize
        window.addEventListener("resize", debouncedResizeHandler);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const { cardItems = [] } = data ?? {};

    return (
        <div className={`col-12 px-1.25   ${styles.slider}`} ref={sectionRef}>
            <Slider {...settings}>
                {cardItems?.map((card) => {
                    const cardImage = getCardMedia(card);
                    return (
                        <div className="px-2.5" key={card.id}>
                            <div className="bg-white rounded shadow-lg flex flex-col">
                                <p className="pb-5 pt-4.25 px-7.5 text-green text-base font-semibold leading-snug tracking-tight border-b-3 border-solid border-Green card-title text-stone">
                                    {card.title}
                                </p>
                                <Media
                                    media={cardImage}
                                    className="w-full mt-5 md:mt-0 lg:h-full object-cover aspect-ratio-75"
                                />
                                <div
                                    className={`p-7.5 pt-8 pr-7.75 ${styles.mobileRichtext} h-inherit flex flex-col justify-between`}
                                >
                                    <div>
                                        <h3 className="text-md font-semibold leading-tight tracking-tight4 mb-2.5">
                                            {card.subtitle}
                                        </h3>
                                        {card.body && <RichText data={card} />}
                                    </div>

                                    {card?.cta && card?.cta?.length > 0 && (
                                        <div className="flex-col lg:flex-row ">
                                            <div>
                                                {card?.cta?.map((ct) => (
                                                    <Cta key={ct.id} data={ct} className="block mt-7.5" />
                                                ))}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
};

export default MobileTabsScrollingSection;
